import { render, staticRenderFns } from "./ChoiceAnswer.vue?vue&type=template&id=34784773&scoped=true"
import script from "./ChoiceAnswer.vue?vue&type=script&lang=js"
export * from "./ChoiceAnswer.vue?vue&type=script&lang=js"
import style0 from "./ChoiceAnswer.vue?vue&type=style&index=0&id=34784773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34784773",
  null
  
)

export default component.exports